import { styled } from "@mui/system";
import React, { useEffect } from "react";
import { useState } from "react";
import { getProjectCategories, getProjectTemplates } from "../api";
import FeaturedBanner from "../components/HomePage/FeaturedBanner";
import WorkflowBanner from "../components/HomePage/WorkflowBanner";
import MarketplaceComponent from "../components/HomePage/MarketplaceComponent";
import TryWorkflow86Button from "../components/HomePage/TryWorkflow86Button";
import { showLoadingScreen } from "../utils/showLoadingScreen";

const MainContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  flexDirection: "column",
  backgroundColor: "#121212",
  paddingTop: "60px",
  minHeight: "100vh",
  paddingBottom: "1rem",
});


export const HomePage = () => {
  const [categories, setCategories] = useState([]);
  const [categoryMapping, setCategoryMapping] = useState(null);
  const [allTemplates, setAllTemplates] = useState([]);
  const [requestsLoaded, setRequestsLoaded] = useState(false);

  useEffect(() => {
    let getProjectTemplatesPromise = getProjectTemplates()
      .then((projectTemplates) => {
        setAllTemplates(projectTemplates);
      })
      .catch((e) => {
        console.log(e);
      });

    let getProjectCategoriesPromise = getProjectCategories()
      .then((categories) => {
        setCategories(categories);

        let categoryMapping = {};

        categories.forEach(({ categoryId, displayName }) => {
          categoryMapping[categoryId] = displayName;
        });

        setCategoryMapping(categoryMapping);
      })
      .catch((error) => {
        console.log(error);
        setCategoryMapping({});
      });

    Promise.all([getProjectTemplatesPromise, getProjectCategoriesPromise]).then(
      () => {
        setRequestsLoaded(true);
      }
    );
  }, []);

  return (
    <MainContainer>
      {requestsLoaded ? (
        <>
          <MarketplaceComponent
            categories={categories}
            categoryMapping={categoryMapping}
            allTemplates={allTemplates}
          />
        </>
      ) : (
        showLoadingScreen()
      )}
    </MainContainer>
  );
};
